import { render, staticRenderFns } from "./domesticDebt.vue?vue&type=template&id=17b9be50&scoped=true&"
import script from "./domesticDebt.vue?vue&type=script&lang=js&"
export * from "./domesticDebt.vue?vue&type=script&lang=js&"
import style0 from "./domesticDebt.vue?vue&type=style&index=0&id=17b9be50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b9be50",
  null
  
)

export default component.exports